import {ISocketConnection, rpc_call} from "../rpc";

export async function rpc_statsInit(socket: ISocketConnection, startTime: number, days: number, hourly?: boolean){
    return await rpc_call<ServerStats>(socket, "StatsInit", startTime, days, hourly);
}

export interface ServerStats {
    players: ServerStatValue[]
    fps: ServerStatValue[]
    entities: ServerStatValue[]
    memory: ServerStatValue[]
}

export interface ServerStatValue {
    readonly timestamp: number

    readonly p01: number
    readonly p05: number
    readonly p50: number
    readonly p95: number
    readonly p99: number
}
